import axios from 'axios';
import { message } from 'core/constant/constants';
import { toast } from 'react-toastify';

const defaultHeaders = {
  authorization: `Bearer ${localStorage.getItem("token")}`
};

const checkExpireToken = (data) => {
  if (data == message?.invalidCredentials) {
    localStorage.removeItem('token');
  }
}

export const postApi = async (url, data, customHeaders = {}) => {
  try {

    const headers = {
      ...defaultHeaders,
      ...customHeaders
    }
    const response = await axios.post(url, data, { headers });
    toast.success(response?.data?.message);
    return response.data;
  } catch (error) {
    checkExpireToken(error?.response?.data?.message)
    toast.error(error?.response?.data?.message);
    console.error('API Error:', error.response || error.message);
    // throw new Error(error.response ? error.response.data : error.message);
  }
};

export const putApi = async (url, data, customHeaders = {}) => {
  try {
    const headers = {
      ...defaultHeaders,
      ...customHeaders
    }
    const response = await axios.put(url, data, { headers });
    toast.success(response?.data?.message);
    return response.data;
  } catch (error) {
    checkExpireToken(error?.response?.data?.message)
    toast.error(error?.response?.data?.message);
    console.error('API Error:', error.response || error.message);
    // throw new Error(error.response ? error.response.data : error.message);
  }
};

export const getApi = async (url) => {
  try {
    const response = await axios.get(url, { headers: defaultHeaders });
    return response.data;
  } catch (error) {
    checkExpireToken(error?.response?.data?.message)
    toast.error(error?.response?.data?.message);
    console.error('API Error:', error.response || error.message);
    // throw new Error(error.response ? error.response.data : error.message);
  }
};